import { init as amplitudeInit, identify, Identify, setUserId } from '@amplitude/analytics-browser'
import React from 'react'
import { useAccount } from 'wagmi'
import { env } from 'env.client'
import { useAmplitude } from 'hooks/useAmplitude'

export const AmplitudeProvider = ({ children }: { children: React.ReactNode }) => {
  const [isAmplitudeInitialized, setIsAmplitudeInitialized] = React.useState(false)
  const { address, connector, status } = useAccount()
  const { trackEvent } = useAmplitude()

  React.useEffect(() => {
    if (env.NEXT_PUBLIC_AMPLITUDE_API_KEY) {
      amplitudeInit(env.NEXT_PUBLIC_AMPLITUDE_API_KEY, undefined, {
        serverZone: process.env.NODE_ENV === 'production' ? 'US' : 'EU',
        defaultTracking: {
          pageViews: true,
          sessions: true,
        },
      })

      setIsAmplitudeInitialized(true)
    }
  }, [])

  React.useEffect(() => {
    if (isAmplitudeInitialized && status === 'connected' && address) {
      trackEvent('wallet_connected', { walletType: connector?.name || 'unknown' })

      setUserId(address)

      // Set the wallet user property after detecting a wallet connection
      const identifySetProperties = new Identify()
      identifySetProperties.set('walletType', connector?.name || 'unknown')
      identify(identifySetProperties)
    }
  }, [trackEvent, status, address, connector, isAmplitudeInitialized])

  return <>{children}</>
}
